//@flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import getter from 'dibs-object-getter';

import styles from './MoreProjects.scss';

import type { MoreProjects_tradeFirm as TradeFirmType } from './__generated__/MoreProjects_tradeFirm.graphql';

const ProjectIcon = (props: { name: ?string, coverPhoto: ?string, url: ?string }) => {
    const backgroundStyle = {
        background: `url(${props.coverPhoto || ''}?width=150)`,
    };
    return <a href={props.url} style={backgroundStyle} className={styles.projectTile} />;
};

type MoreProjectsProps = {
    isLoading: boolean,
    tradeFirm: ?TradeFirmType,
    projectId?: ?string,
};

export const MoreProjects = (props: MoreProjectsProps) => {
    const getProps = getter(props);
    const isLoading = getProps.value('isLoading');
    const designProjects = (
        getProps
            .at('tradeFirm')
            .at('publicProfile')
            .value('designProjectsCover') || []
    )
        .filter(project => project && project.serviceId !== props.projectId)
        .slice(0, 4);

    return (
        <div className={styles.wrapper}>
            <div className={`${styles.container} ${isLoading ? styles.isLoading : ''}`.trim()}>
                {!!designProjects.length && (
                    <React.Fragment>
                        <span className={styles.labelText}>
                            <FormattedMessage
                                id="interiorPhoto.rail.moreProjects.byline"
                                defaultMessage="More Projects by {firmName}"
                                values={{
                                    firmName: getProps.at('tradeFirm').value('name'),
                                }}
                            />
                        </span>
                        <div className={styles.tileContainer}>
                            {designProjects.map((project, index) =>
                                project ? (
                                    <ProjectIcon key={`projectTile-${index}`} {...project} />
                                ) : null
                            )}
                        </div>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
};

export default createFragmentContainer(MoreProjects, {
    tradeFirm: graphql`
        fragment MoreProjects_tradeFirm on TradeFirmType {
            name
            publicProfile {
                designProjectsCover {
                    serviceId
                    name
                    coverPhoto
                    url
                }
            }
        }
    `,
});
